import { DatePicker, Select, Row, Col } from 'antd';
import dayjs from 'dayjs';
import {
  FluxoCaixaCategoria,
  FluxoCaixaCentroCusto,
  FluxoCaixaFiltros,
  FluxoCaixaTipo,
  FLUXO_CAIXA_CATEGORIA_LABELS,
  FLUXO_CAIXA_CENTRO_CUSTO_LABELS,
  FLUXO_CAIXA_TIPO_LABELS,
} from '../types/fluxoCaixa';

const { RangePicker } = DatePicker;

interface FluxoCaixaFiltersProps {
  filtros: FluxoCaixaFiltros;
  onChange: (filtros: FluxoCaixaFiltros) => void;
}

export function FluxoCaixaFilters({ filtros, onChange }: FluxoCaixaFiltersProps) {
  const handlePeriodoChange = (dates: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null) => {
    if (!dates || !dates[0] || !dates[1]) return;
    onChange({
      ...filtros,
      dataInicio: dates[0].format('YYYY-MM-DD'),
      dataFim: dates[1].format('YYYY-MM-DD'),
    });
  };

  return (
    <Row gutter={[12, 12]} className="mb-4">
      <Col xs={24} md={8}>
        <label className="text-xs text-gray-500 dark:text-zinc-400 font-medium block mb-1">
          Período
        </label>
        <RangePicker
          className="w-full"
          format="DD/MM/YYYY"
          value={[dayjs(filtros.dataInicio), dayjs(filtros.dataFim)]}
          onChange={handlePeriodoChange}
          disabledDate={current => current && current > dayjs().endOf('day')}
        />
      </Col>

      <Col xs={24} sm={12} md={5}>
        <label className="text-xs text-gray-500 dark:text-zinc-400 font-medium block mb-1">
          Tipo
        </label>
        <Select
          className="w-full"
          allowClear
          placeholder="Todos"
          value={filtros.tipo ?? undefined}
          onChange={(value: FluxoCaixaTipo | undefined) =>
            onChange({ ...filtros, tipo: value ?? null })
          }
        >
          {Object.values(FluxoCaixaTipo).map(tipo => (
            <Select.Option key={tipo} value={tipo}>
              {FLUXO_CAIXA_TIPO_LABELS[tipo]}
            </Select.Option>
          ))}
        </Select>
      </Col>

      <Col xs={24} sm={12} md={5}>
        <label className="text-xs text-gray-500 dark:text-zinc-400 font-medium block mb-1">
          Categoria
        </label>
        <Select
          className="w-full"
          mode="multiple"
          allowClear
          placeholder="Todas"
          maxTagCount="responsive"
          value={filtros.categorias}
          onChange={(value: FluxoCaixaCategoria[]) =>
            onChange({ ...filtros, categorias: value })
          }
        >
          {Object.values(FluxoCaixaCategoria).map(cat => (
            <Select.Option key={cat} value={cat}>
              {FLUXO_CAIXA_CATEGORIA_LABELS[cat]}
            </Select.Option>
          ))}
        </Select>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <label className="text-xs text-gray-500 dark:text-zinc-400 font-medium block mb-1">
          Centro de Custo
        </label>
        <Select
          className="w-full"
          mode="multiple"
          allowClear
          placeholder="Todos"
          maxTagCount="responsive"
          value={filtros.centrosCusto}
          onChange={(value: FluxoCaixaCentroCusto[]) =>
            onChange({ ...filtros, centrosCusto: value })
          }
        >
          {Object.values(FluxoCaixaCentroCusto).map(cc => (
            <Select.Option key={cc} value={cc}>
              {FLUXO_CAIXA_CENTRO_CUSTO_LABELS[cc]}
            </Select.Option>
          ))}
        </Select>
      </Col>
    </Row>
  );
}
